var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9231 14.8459C28.8815 22.5778 22.5798 28.8801 14.8479 28.9226C7.11602 28.965 0.881883 22.7315 0.92356 14.9997C0.965237 7.2678 7.26694 0.965449 14.9988 0.922979C22.7307 0.880509 28.9648 7.114 28.9231 14.8459ZM2.32354 14.992C2.28603 21.9507 7.89675 27.5608 14.8554 27.5226C21.8141 27.4844 27.4856 21.8123 27.5232 14.8536C27.5607 7.89488 21.9499 2.28474 14.9913 2.32296C8.03258 2.36118 2.36105 8.0333 2.32354 14.992Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8523 2.28223C18.9003 1.38379 16.7676 0.946771 14.6195 1.00502L14.999 14.9999L20.8523 2.28223Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/PENDING.f31ce65eda81d2c7707d336866ce7b8e.svg";
export { ForwardRef as ReactComponent };